import React from 'react';
import './itemsListView.css';
import { func, array } from 'prop-types';

const ItemsListView = ({ itemList, renderItem, onItemSelected }) => (
  <ul className="item-list list-group">
    {itemList.map(item => {
      const { id } = item

      const label = renderItem(item)

      return (
        <li
          key={id}
          className="list-group-item"
          onClick={() => onItemSelected(id)}
        >
          {label}
        </li>
      )
    })}
  </ul>
)

ItemsListView.propTypes = {
  renderItem: func,
  onItemSelected: func,
  itemList: array,
}

ItemsListView.defaultProps = {
  renderItem: () => { },
  onItemSelected: () => { },
  itemList: [],
}

export default ItemsListView